<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新增杠杆列表"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="val" ref="form" label-width="170px" :rules="rules">
        <el-form-item label="交易对选择：" prop="pair">
          <el-select v-model="val.pair">
            <el-option
              v-for="item in pairList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <span style="margin-left:20px;">说明：杠杆交易对不能重复添加哦</span>
        </el-form-item>
        <el-form-item label="爆仓风险率：" prop="burstRate">
          <el-input-number
            v-model="val.burstRate"
            :min="0.0001"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="借贷利率：" prop="interestRate">
          <el-input-number v-model="val.interestRate"></el-input-number>
        </el-form-item>
        <el-form-item label="最大杠杆倍数：" prop="maxMultiple">
          <el-input-number v-model="val.maxMultiple" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item
          v-show="val.pair"
          :label="`最小${val.pair && val.pair.split('_')[0]}借币数量：`"
          prop="coinMinAmount"
        >
          <el-input-number v-model="val.coinMinAmount"></el-input-number>
        </el-form-item>
        <el-form-item
          v-show="val.pair"
          :label="`最小${val.pair && val.pair.split('_')[1]}借币数量：`"
          prop="setMinAmount"
        >
          <el-input-number v-model="val.setMinAmount"></el-input-number>
        </el-form-item>
        <el-form-item label="转出后最小风险率：" prop="outRate">
          <el-input-number v-model="val.outRate"></el-input-number>
          <span style="margin-left:20px;"
            >说明：转出后杠杆账户风险率不能低于当前设置值</span
          >
        </el-form-item>
        <el-form-item label="报警风险率：" prop="warnRate">
          <el-input-number v-model="val.warnRate"></el-input-number>
        </el-form-item>
        <el-form-item label="是否开启：" prop="open">
          <el-switch v-model="val.open"></el-switch>
        </el-form-item>
        <el-form-item label="类型：" prop="type">
          <el-select v-model="val.type">
            <el-option
              v-for="item in tyleList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
// import MutipleInput from '../mutipleInput';
import Upload from 'components/upload';

export default {
  name: 'cornucopiaCreate',
  data() {
    return {
      dialogVisible: false,
      val: {},
      tyleList: [
        { value: 1, label: '全仓' },
        { value: 2, label: '逐仓' },
        { value: 3, label: '全仓+逐仓' }
      ],
      rules: {
        pair: {
          required: true,
          message: '请填写'
        },
        burstRate: {
          required: true,
          message: '请填写'
        },
        interestRate: {
          required: true,
          message: '请填写'
        },
        maxMultiple: {
          required: true,
          message: '请填写'
        },
        coinMinAmount: {
          required: true,
          message: '请填写'
        },
        setMinAmount: {
          required: true,
          message: '请填写'
        },

        outRate: {
          required: true,
          message: '请填写'
        },
        warnRate: {
          required: true,
          message: '请填写'
        },
        open: {
          required: true,
          message: '请填写'
        },
        type: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {
    // MutipleInput,
    Upload
  },
  computed: {
    ...mapState('lever', ['pairList', 'languageList'])
  },
  methods: {
    ...mapActions('lever', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.create({ ...this.val }).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh');
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
